import { MenuRightsManagement } from './menu-rights-management';

export class RightsManagement {
  public menu: MenuRightsManagement;
  public view: boolean;
}
